export default {
      id: "ar_logement-usage",
      viewBox: "0 0 230 150",
      url: "../dist/images/" + "sprite.svg#ar_logement-usage",
      toString: function () {
        return this.url;
      }
    }